module.exports = __webpack_public_path__ + "images/logo_suites_icon.webp";